export default __webpack_public_path__ + "static/media/streaks 250.d44ff6c5.svg";